import React from "react";

const Legend = ({ legendColors, legendLabels }) => {
  return (
    <React.Fragment>
      <div style={{ display: "flex", marginTop: "20px" }}>
        <div style={{ width: "40px" }} />
        {[1, 1].map(el => (
          <div
            style={{
              width: "84px",
              height: "8px",
              margin: "6px",
              backgroundColor: "white",
              flex: "1 1 0%"
            }}
          />
        ))}
        {legendColors.map((el, i) => {
          return (
            <div
              style={{
                width: "84px",
                height: "8px",
                margin: "6px",
                backgroundColor: legendColors[i],
                flex: "1 1 0%"
              }}
            />
          );
        })}
        {[1, 1].map(el => (
          <div
            style={{
              width: "84px",
              height: "8px",
              margin: "6px",
              backgroundColor: "white",
              flex: "1 1 0%"
            }}
          />
        ))}
      </div>
      <div style={{ display: "flex", marginTop: "2px" }}>
        <div style={{ width: "40px" }} />
        {[1, 1].map(el => (
          <div
            style={{
              width: "84px",
              height: "8px",
              margin: "6px",
              backgroundColor: "white",
              flex: "1 1 0%"
            }}
          />
        ))}
        {legendLabels.map((el, i) => {
          return (
            <div
              style={{
                width: "84px",
                height: "8px",
                margin: "6px",
                backgroundColor: legendLabels[i],
                flex: "1 1 0%",
                textAlign: "center",
                fontSize: "12px",
                color: "#909090"
              }}
            >
              {legendLabels[i]}
            </div>
          );
        })}
        {[1, 1].map(el => (
          <div
            style={{
              width: "84px",
              height: "8px",
              margin: "6px",
              backgroundColor: "white",
              flex: "1 1 0%"
            }}
          />
        ))}
      </div>
    </React.Fragment>
  );
};

export default Legend;
